"use client";

import { AdminConfigProvider } from '@/contexts/AdminConfigContext';
import { CapstoneProvider } from '@/contexts/CapstoneContext';
import { SidebarProvider } from '@/contexts/SidebarContext';
import { AuthProvider } from '@/contexts/AuthContext';
import { PermissionsProvider } from '@/contexts/PermissionsContext';
import { InventoryProvider } from '@/contexts/InventoryContext';
import { StudentsProvider } from '@/contexts/StudentsContext';
import { CartProvider } from '@/contexts/CartContext';
import { Inventory25CartProvider } from '@/contexts/inventory25/CartContext';
import { CheckoutProvider } from '@/contexts/CheckoutContext';
import { UserPreferencesProvider } from '@/contexts/UserPreferencesContext';
import { BrandAbProvider } from '@/contexts/BrandAbContext';
import BrandWatermark from '@/components/BrandWatermark';
import UpdateAlertBanner from '@/components/UpdateAlertBanner';
import NavBaselineProbe from '@/components/NavBaselineProbe';

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <BrandAbProvider>
      <UserPreferencesProvider>
        <AdminConfigProvider>
          <SidebarProvider>
            <AuthProvider>
              <PermissionsProvider>
                <InventoryProvider>
                  <StudentsProvider>
                    <CartProvider>
                      <Inventory25CartProvider>
                        <CheckoutProvider>
                          <CapstoneProvider>
                            <BrandWatermark />
                            <UpdateAlertBanner />
                            <NavBaselineProbe />
                            <div className="relative z-[1] h-full">{children}</div>
                          </CapstoneProvider>
                        </CheckoutProvider>
                      </Inventory25CartProvider>
                    </CartProvider>
                  </StudentsProvider>
                </InventoryProvider>
              </PermissionsProvider>
            </AuthProvider>
          </SidebarProvider>
        </AdminConfigProvider>
      </UserPreferencesProvider>
    </BrandAbProvider>
  );
}
